// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signature-view[data-v-45ec330c] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 160px;\n  border: 1px solid #d5dcdf;\n  border-radius: 4px;\n  background: #fafafa;\n}\n.signature-view img[data-v-45ec330c] {\n  max-width: 100%;\n  max-height: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
